<div class="export-row-container">
  <div class="table-body-head">
    <div class="export-container">
      <tui-hosted-dropdown
        tuiDropdownLimitWidth="auto"
        [content]="download_options"
        [(open)]="open"
      >
        <button
          tuiHostedDropdownHost
          class="export-button"
          type="button"
          [disabled]="isLoading || paginatedData.length === 0"
        >
          <img
            src="assets/icons/download-Icon.svg"
            alt="download"
            class="img-icon"
          />
          {{ "services_not_started_table.export_text" | translate }}
        </button>
      </tui-hosted-dropdown>
    </div>
  </div>
</div>

<!-- Filtros -->
<form class="table-body-options" [formGroup]="filtersForm">
  <!-- Buscador -->
  <div class="search-bar">
    <img
      src="assets/icons/search-icon.svg"
      alt="Search Icon"
      class="search-icon"
    />
    <input
      id="searchInput"
      class="search-bar-input"
      type="text"
      [disabled]="isLoading"
      formControlName="search"
      placeholder="{{ 'services_not_started_table.search_text' | translate }}"
    />
  </div>

  <!-- Rango de fechas -->
  <tui-input-date-range
    class="custom_select"
    [disabled]="isLoading"
    formControlName="dateRange"
    tuiTextfieldSize="s"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldLabelOutside]="true"
  >
    {{ "services_not_started_table.date_input" | translate }}
    <input
      placeholder="{{
        'services_not_started_table.date_range_placeholder' | translate
      }}"
      tuiTextfield
    />
  </tui-input-date-range>

  <!-- Zona -->
  <ng-select
    class="custom_select"
    [items]="zones"
    bindLabel="zoneName"
    bindValue="zoneName"
    formControlName="zones"
    [multiple]="true"
    [disabled]="isLoading"
    [dropdownPosition]="'bottom'"
    placeholder="{{
      'services_not_started_table.origin_zone_input_table' | translate
    }}"
  >
  </ng-select>

  <!-- Products -->

  <ng-select
    class="filter-item custom_select"
    formControlName="products"
    [bindLabel]="'ProductKey'"
    [bindValue]="'ProductName'"
    [loading]="isLoadingProducts"
    [items]="products"
    [multiple]="true"
    [clearable]="true"
    placeholder="{{
      'service_manager.pending_service.products_input' | translate
    }}"
  ></ng-select>

  <!-- Estado -->
  <ng-select
    class="custom_select"
    [items]="orderStatus"
    bindLabel="statusName"
    bindValue="nodeStatus"
    formControlName="status"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{
      'services_not_started_table.status_input_table' | translate
    }}"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item.statusName | translate }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.statusName | translate }}
    </ng-template>
  </ng-select>

  <!-- Clientes -->
  <ng-select
    class="custom_select"
    [items]="allClients"
    bindLabel="clientName"
    bindValue="clientName"
    formControlName="clients"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    [disabled]="isLoading"
    placeholder="{{ 'services_not_started_table.clients_input' | translate }}"
  >
  </ng-select>

  <!-- Conductores -->
  <ng-select
    class="custom_select"
    [items]="allDrivers"
    bindLabel="driverName"
    bindValue="driverName"
    formControlName="drivers"
    [multiple]="true"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'services_not_started_table.drivers_input' | translate }}"
  >
  </ng-select>

  <!-- ER [13/08/2025] - Pending to implemente the endpoint getAllProducts -->
  <!-- Productos -->
  <!-- <ng-select
    class="custom_select"
    [items]="products"
    bindLabel="productName"
    bindValue="productName"
    formControlName="product"
    [multiple]="true"
    [disabled]="isLoading"
    [dropdownPosition]="'bottom'"
    placeholder="{{ 'services_not_started_table.products_input' | translate }}"
  >
  </ng-select> -->
</form>

<!-- Tabla -->
<div class="table-wrapper">
  <table tuiTable size="l" [columns]="columns">
    <thead tuiThead>
      <tr tuiThGroup>
        <th
          class="th-style"
          *tuiHead="'licensePlate'"
          tuiTh
          (click)="setSortColumn('licensePlate')"
        >
          {{ "services_not_started_table.plate_input_table" | translate }}
        </th>

        <th *tuiHead="'time'" tuiTh (click)="setSortColumn('startHour')">
          {{ "services_not_started_table.hour_input_table" | translate }}
        </th>

        <th *tuiHead="'orderHash'" tuiTh (click)="setSortColumn('orderHash')">
          {{ "services_not_started_table.hash_input_table" | translate }}
        </th>

        <th *tuiHead="'zone'" tuiTh (click)="setSortColumn('zoneName')">
          {{ "services_not_started_table.origin_zone_input_table" | translate }}
        </th>

        <th
          *tuiHead="'date'"
          tuiTh
          (click)="setSortColumn('assignedStartDate')"
        >
          {{ "services_not_started_table.date_input_table" | translate }}
        </th>

        <th *tuiHead="'product'" tuiTh (click)="setSortColumn('productName')">
          {{ "services_not_started_table.product_input_table" | translate }}
        </th>

        <th *tuiHead="'status'" tuiTh (click)="setSortColumn('status')">
          {{ "services_not_started_table.status_input_table" | translate }}
        </th>

        <th *tuiHead="'hasDeliveryNote'" tuiTh (click)="setSortColumn('hasDeliveryNote')">
          {{ "services_not_started_table.delivery_note_column" | translate }}
        </th>

        <th
          *tuiHead="'startAddress'"
          tuiTh
          (click)="setSortColumn('startAddress')"
        >
          {{
            "services_not_started_table.pickup_address_input_table" | translate
          }}
        </th>

        <th *tuiHead="'endAddress'" tuiTh (click)="setSortColumn('endAddress')">
          {{ "services_not_started_table.delivery_input_table" | translate }}
        </th>

        <th *tuiHead="'client'" tuiTh (click)="setSortColumn('clientName')">
          {{ "services_not_started_table.client_input_table" | translate }}
        </th>

        <th *tuiHead="'driver'" tuiTh (click)="setSortColumn('driverName')">
          {{ "services_not_started_table.column_driver" | translate }}
        </th>

        <th *tuiHead="'totalPrice'" tuiTh (click)="setSortColumn('totalPrice')">
          {{ "services_not_started_table.column_price" | translate }}
        </th>

        <th *tuiHead="'activeBid'" tuiTh (click)="setSortColumn('activeBid')">
          {{ "services_not_started_table.column_active_bid" | translate }}
        </th>

        <th *tuiHead="'actions'" tuiTh [sorter]="null">
          {{ "services_not_started_table.column_actions" | translate }}
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <ng-container *ngIf="!isLoading && paginatedData.length > 0">
        <!-- Itera sobre los datos paginados -->
        <tr tuiTr *ngFor="let item of paginatedData; trackBy: trackByOrderHash">
          <!-- Matricula -->
          <td *tuiCell="'licensePlate'" tuiTd>
            <div class="vertical-align">
              <span tuiTitle>{{ display(item.licensePlate) }}</span>
            </div>
          </td>

          <!-- Hora -->
          <td *tuiCell="'time'" tuiTd>
            <div [tuiCell]="size">
              <span
                tuiTitle
                [ngClass]="{
                  'red-text': isWithin48Hours(
                    item.assignedStartDate,
                    item.driverName
                  )
                }"
              >
                {{ formatHourRange(item.assignedStartDate, item.endDate) }}
              </span>
            </div>
          </td>

          <!-- Hash -->
          <td *tuiCell="'orderHash'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ display(item.orderHash) }}</span>
            </div>
          </td>

          <!-- Zona -->
          <td *tuiCell="'zone'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>{{ display(item.zoneName) }}</span>
            </div>
          </td>

          <!-- Fecha -->
          <td *tuiCell="'date'" tuiTd>
            <div [tuiCell]="size">
              <img
                *ngIf="isWithin48Hours(item.assignedStartDate, item.driverName)"
                src="assets/icons/alert-red-circle.svg"
                alt="{{ 'services_not_started_table.alert_icon' | translate }}"
                class="alert-icon"
                [tuiHint]="
                  ('services_not_started_table.tooltip_service_on'
                    | translate) +
                  ' ' +
                  formatDate(item.assignedStartDate) +
                  ' · ' +
                  formatHourRange(item.assignedStartDate, item.endDate) +
                  (isWithin48Hours(item.assignedStartDate, item.driverName)
                    ? ' · ' +
                      ('services_not_started_table.tooltip_within_48h'
                        | translate)
                    : '')
                "
              />
              <span
                tuiTitle
                [tuiHint]="
                  formatDate(item.assignedStartDate) +
                  ' · ' +
                  formatHourRange(item.assignedStartDate, item.endDate) +
                  (isWithin48Hours(item.assignedStartDate, item.driverName)
                    ? ' · ' +
                      ('services_not_started_table.tooltip_within_48h'
                        | translate)
                    : '')
                "
                tuiHintDirection="top"
                [ngClass]="{
                  'red-text': isWithin48Hours(
                    item.assignedStartDate,
                    item.driverName
                  )
                }"
              >
                {{ formatDate(item.assignedStartDate) }}
              </span>
            </div>
          </td>

          <!-- Producto -->
          <td *tuiCell="'product'" tuiTd>
            <span tuiTitle>
              {{
                item.productName ||
                  ("services_not_started_table.no_product" | translate)
              }}
            </span>
          </td>

          <!-- Cliente -->
          <td *tuiCell="'client'" tuiTd>
            <span tuiTitle>{{ display(item.clientName) }}</span>
          </td>

          <!-- Dirección origen -->
          <td *tuiCell="'startAddress'" tuiTd>
            <span tuiTitle>
              {{
                item.startAddress ||
                  ("services_not_started_table.no_address" | translate)
              }}
            </span>
          </td>

          <!-- Dirección destino -->
          <td *tuiCell="'endAddress'" tuiTd>
            <span tuiTitle>
              {{
                item.endAddress ||
                  ("services_not_started_table.no_address" | translate)
              }}
            </span>
          </td>

          <!-- Estado -->
          <td *tuiCell="'status'" tuiTd>
            <tui-badge
              *ngIf="item.nodeStatus !== null && item.nodeStatus !== undefined"
              [status]="getOrderStatusMeta(item.nodeStatus).tuiStatus"
              [value]="getOrderStatusMeta(item.nodeStatus).label | translate"
              [class]="getOrderStatusMeta(item.nodeStatus).cssClass"
            ></tui-badge>
          </td>

          <!-- Albarán -->
          <td *tuiCell="'hasDeliveryNote'" tuiTd>
            <div class="delivery-note-cell">
              <span tuiTitle>
                {{ item.hasDeliveryNote ? ('services_not_started_table.yes' | translate) : ('services_not_started_table.no' | translate) }}
              </span>
            </div>
          </td>

          <!-- Conductor -->
          <td *tuiCell="'driver'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle *ngIf="item.driverName?.trim(); else noDriver">
                {{ item.driverName }}
              </span>
              <ng-template #noDriver>
                <tui-tag
                  class="tag"
                  status="custom"
                  [hoverable]="true"
                  [value]="'services_not_started_table.unassigned' | translate"
                ></tui-tag>
              </ng-template>
            </div>
          </td>

          <!-- Precio -->
          <td *tuiCell="'totalPrice'" tuiTd>
            <div [tuiCell]="size">
              <ng-container *ngIf="item?.totalPrice != null; else noPrice">
                <span tuiTitle tuiCell="l">
                  {{ item.totalPrice | number : "1.2-2" }}
                  {{ item.currencySymbol }}
                </span>
              </ng-container>

              <ng-template #noPrice>
                <span tuiTitle>–</span>
              </ng-template>
            </div>
          </td>

          <!-- Pujas -->
          <td *tuiCell="'activeBid'" tuiTd>
            <div class="bid-cell" [tuiCell]="size">
              <button
                size="s"
                class="bind"
                tuiButton
                type="button"
                appearance="outline"
              >
                <div class="gavel-container">
                  <img
                    src="assets/icons/gavel.svg"
                    alt="Icono"
                    width="20"
                    height="20"
                  />
                  <span> {{ item.userBidCount }}</span>
                </div>
              </button>
            </div>
          </td>

          <!-- Acciones -->
          <td *tuiCell="'actions'" tuiTd>
            <span tuiStatus>
              <button
                class="seeAllIcon"
                appearance="link"
                icon="tuiIconEye"
                size="xs"
                tuiAppearance="link"
                tuiIconButton
                (click)="viewDetail(item)"
              >
                <span>
                  {{
                    "services_not_started_table.action_view_results" | translate
                  }}
                </span>
              </button>

              <!-- Editar: muestra spinner mientras se carga -->
              <ng-container
                *ngIf="!isRowLoading(item.orderHash); else editLoading"
              >
                <button
                  appearance="link"
                  icon="tuiIconEdit2"
                  size="xs"
                  tuiAppearance="link"
                  tuiIconButton
                  (click)="openModalEditService(item)"
                >
                  {{ "services_not_started_table.action_edit" | translate }}
                </button>
              </ng-container>
              <ng-template #editLoading>
                <tui-loader size="s"></tui-loader>
              </ng-template>
            </span>
          </td>
        </tr>
      </ng-container>

      <!-- Loader -->
      <tr *ngIf="isLoading">
        <td [attr.colspan]="15" class="horizontal-text-center">
          <tui-loader size="l"></tui-loader>
        </td>
      </tr>

      <!-- Vacío -->
      <tr *ngIf="!isLoading && paginatedData.length === 0">
        <td [attr.colspan]="15" class="empty-message">
          {{ "services_not_started_table.empty_search" | translate }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Paginación -->
<div class="table-pagination" *ngIf="!isLoading && paginatedData.length > 0">
  <tui-pagination
    [index]="index"
    [length]="length"
    (indexChange)="goToPage($event)"
  ></tui-pagination>
</div>

<!-- ▒▒▒  TEMPLATE: Export opciones  ▒▒▒ -->
<ng-template #download_options>
  <div class="download-menu">
    <h3 class="export-title">
      {{ "services_not_started_table.complement_export_text" | translate }}
    </h3>

    <div class="checkbox-container">
      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportXlsx"></tui-checkbox>
        <span class="export-body-label">
          {{ "services_not_started_table.export_excel" | translate }}
        </span>
      </div>

      <div class="checkbox-container-row">
        <tui-checkbox [(ngModel)]="exportCsv"></tui-checkbox>
        <span class="export-body-label">
          {{ "services_not_started_table.export_csv" | translate }}
        </span>
      </div>
    </div>

    <button
      type="button"
      class="export-button-menu"
      (click)="exportSelected()"
      [disabled]="!exportCsv && !exportXlsx"
    >
      <img src="assets/icons/download-Icon.svg" alt="" class="img-icon" />
      <span>{{ "services_not_started_table.export_text" | translate }}</span>
    </button>
  </div>
</ng-template>
